<app-score-dashboard
    [title]="title"
    [trendingTitle]="'SLA Trending'"
    [centerText]="'My Score'"
    [showScore]="true"
    [showTrending]="true"
    [loadScoreData]="loadScoreData"
    [loadTrendingData]="loadTrendingData"
    [showBreakdownCharts]="false"
    [useCapitalCaseFormatting]="false"
    [scoreCountsAsData]="true"
    [exportData]="exportData">
</app-score-dashboard>
